import styled from 'styled-components'
import FontAwesome from 'components/FontAwesome'
import media from 'utils/media'

export const StyledMobileNav = styled.div`
   height: ${({ $isOpen }) => ($isOpen ? '100vh' : 0)};
   width: 100vw;
   padding: 0 24px;

   ${media.greaterThan('md')`
      padding: 0 50px;
   `}

   display: flex;
   flex-direction: column;
   justify-content: flex-start;
   position: fixed;
   z-index: ${({ $isOpen }) => ($isOpen ? '9' : '-1')};
   top: 0;
   right: 0;
   opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
   background-color: ${({ theme }) => theme.colors.mobileNavBg};
   transition: opacity 0.2s cubic-bezier(0, 0.89, 0.44, 1);

   & > div {
      overflow: scroll;

      @media only screen and (max-width: 990px) and (orientation: landscape) {
         padding: 120px 33px;
         height: min-content;
      }
   }

   ${media.greaterThan('lg')`
      display: none;
  `};
`

export const StyledController = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   flex-wrap: wrap;
   gap: ${({ $isActive }) => ($isActive ? '24px' : 0)};
   margin-top: 130px;

   ${media.greaterThan('md')`
      margin-top: 146px;
   `}

   & > div:first-of-type {
      display: flex;
      align-items: center;
      gap: 8px;
   }
`

export const StyledActiveMenu = styled.div`
   flex: 1 1 100%;
   padding: ${({ $isActive }) => ($isActive ? '24px' : 0)};
   height: ${({ $isActive }) => ($isActive ? 104 : 0)};
   background-color: ${({ theme }) => (theme.darkMode ? theme.colors.accent : theme.colors.white)};
   border-radius: 6px;
   border: ${({ $isActive }) => ($isActive ? '1px solid' : 'none')};
   border-color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};
`

export const StyledNavigation = styled.nav`
   margin-top: 32px;
`

export const StyledMenu = styled.ul``

export const MenuElement = styled.li`
   margin-bottom: 0;

   &:not(:last-of-type) {
      margin-bottom: 32px;
   }

   a {
      display: block;
      margin: 0;
      font-size: 36px;
      ${media.greaterThan('md')`
         font-size: 48px;
      `}
      line-height: 1;
      font-weight: 450;
      font-family: ${({ theme }) => theme.fonts.portrait};
      color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};

      &:hover,
      &:focus {
         &::before {
            position: absolute;
            left: -35px;
            top: 50%;
            width: 48px;
            height: 0;
            border-top: 4px solid ${({ theme }) => theme.colors.hotCinnamon};
            transform: rotate(-80deg) translateY(-50%);
            content: '';
         }
      }

      &.is-active {
         position: relative;

         &::before {
            position: absolute;
            left: -35px;
            top: 50%;
            width: 48px;
            height: 0;
            border-top: 4px solid ${({ theme }) => theme.colors.hotCinnamon};
            transform: rotate(-80deg) translateY(-50%);
            content: '';
         }
      }
   }
`
export const StyledControlBtn = styled.button`
   border-radius: 6px;
   border-width: 1px;
   border-style: solid;
   cursor: pointer;
   padding: 10px;
   display: flex;
   width: 40px;
   height: 40px;
   justify-content: center;
   align-items: center;
   border-color: ${({ theme }) => (theme.darkMode ? theme.colors.btnDarkBg : theme.colors.btnOutlineBorderBg)};
   color: ${({ theme }) => (theme.darkMode ? theme.colors.btnDarkColor : theme.colors.btnLightColor)};
   background-color: ${({ theme }) => (theme.darkMode ? theme.colors.btnDarkBg : 'white')};

   svg {
      display: block;
      color: inherit;
   }
`

export const StyledThemeIcon = styled(FontAwesome).attrs(({ theme }) => ({
   icon: theme.darkMode ? 'sun' : 'moon',
}))`
   display: block;
   color: inherit;
`
